<template>
  <v-dialog v-model="ratingDialog" width="300">
    <v-card class="elevation-16 mx-auto" width="300" height="auto">
      <v-card-title class="text-h5">
        {{$t('rate_app')}}
      </v-card-title>
      <v-card-text >
        {{$t('rating_text_1')}}

        <div class="text-center mt-12">
          <v-rating
            v-model="rating"
            color="yellow darken-3"
            background-color="grey darken-1"
            half-increments
            hover
            large
          ></v-rating>
        </div>
        <v-textarea height="20" outlined :label="$t('feedback')" :placeholder="$t('optional')" v-model="feedbackText"  v-if="rating>0" ></v-textarea>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="justify-space-between">
        <v-btn text @click="postponeReview">
          {{$t('no_thanks')}}
        </v-btn>
        <v-btn color="primary" text @click="submitReview" :disabled="rating<0.5">
           {{$t('rate_now')}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { db } from "../../firebaseconfig";
export default {
  props: ["user"],
  data: () => ({
    rating: 0,
    createdOn: "",
    ratingDialog: false,
    feedbackText:'',
    showCount:0,
    days7:604800000
  }),
  mounted() {
    let ref = db.ref("users").child(this.user.uid);
    this.$rtdbBind("createdOn", ref.child("createdOn")).then();
  },
  methods:{
      submitReview(){
         db.ref("users")
                .child(this.user.uid)
                .child('feedback')
                .set({
                    rating:this.rating,
                    feedbackText:this.feedbackText
                }) 
                if(this.rating>3.5){
            this.$emit('store')
                }
                this.ratingDialog=false
      },
      postponeReview(){
          this.showCount++;
          if(this.showCount<4){
              const time=Date.now()+(this.showCount)*this.days7
              db.ref("users")
                .child(this.user.uid)
                .child('appReview')
                .set({ appReviewOn: time , count:this.showCount });
          }
          this.ratingDialog=false
      }
  },
  watch: {
    createdOn(val) {
      if (val['.value']) {
        db.ref("users")
          .child(this.user.uid)
          .child("appReview")
          .once("value")
          .then((data) => {
            if (data.exists()) {
              const review=data.val();
              const currentTime=Date.now();
              this.showCount=review.count;
              if(review.appReviewOn<currentTime){
                  this.ratingDialog=true
              }
              
              
            } else {
              let time = val[".value"] + this.days7;
              db.ref("users")
                .child(this.user.uid)
                .child('appReview')
                .set({ appReviewOn: time , count:1 });
            }
          });
      }
    },
  },
};
</script>
